import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import MarketingShell from "./MarketingShell";

export default function CompareCampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [picked, setPicked] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/marketing/campaigns").then(r => setCampaigns(r.data.filter(c => c.status === "sent"))).catch(() => {});
  }, []);

  const run = async () => {
    if (picked.length < 2) return toast.error("Pick at least 2 campaigns");
    setLoading(true);
    try {
      const r = await api.get(`/marketing/reports/compare?campaign_ids=${picked.join(",")}`);
      setReports(r.data);
    } catch { toast.error("Compare failed"); }
    setLoading(false);
  };

  const fmtPct = v => v === null || v === undefined ? "—" : `${(v * 100).toFixed(1)}%`;

  return (
    <MarketingShell>
      <div className="bg-white border border-[#E5E5E5] p-4 mb-4">
        <p className="text-xs text-[#525252] mb-3">Pick 2 or more sent campaigns to compare side-by-side.</p>
        <div className="flex flex-wrap gap-2">
          {campaigns.map(c => (
            <label key={c.id} className={`px-3 py-1.5 border cursor-pointer text-xs ${picked.includes(c.id) ? "bg-[#EFF6FF] border-[#0055FF] text-[#0055FF]" : "border-[#E5E5E5] hover:border-[#0055FF]"}`} data-testid={`cmp-pick-${c.id}`}>
              <input type="checkbox" checked={picked.includes(c.id)}
                     onChange={() => setPicked(picked.includes(c.id) ? picked.filter(x => x !== c.id) : [...picked, c.id])}
                     className="mr-1.5" />
              {c.name}
            </label>
          ))}
        </div>
        <button onClick={run} disabled={picked.length < 2 || loading}
                className="mt-3 h-9 px-4 bg-[#0055FF] text-white text-xs font-bold uppercase tracking-wider disabled:opacity-40" data-testid="compare-run">
          {loading ? "Loading…" : "Compare"}
        </button>
      </div>

      {reports.length > 0 && (
        <div className="bg-white border border-[#E5E5E5] overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#FAFAFA] text-[10px] uppercase tracking-wider text-[#A3A3A3]">
              <tr>
                <th className="text-left px-5 py-2 font-bold">Metric</th>
                {reports.map(r => <th key={r.campaign.id} className="text-right px-4 py-2 font-bold">{r.campaign.name}</th>)}
              </tr>
            </thead>
            <tbody>
              {[
                ["Sent", r => r.totals.sent],
                ["Delivered", r => r.totals.delivered],
                ["Open rate", r => fmtPct(r.rates.open_rate)],
                ["Click rate", r => fmtPct(r.rates.click_rate)],
                ["Click-to-open", r => fmtPct(r.rates.click_to_open_rate)],
                ["Bounce rate", r => fmtPct(r.rates.bounce_rate)],
                ["Unsub rate", r => fmtPct(r.rates.unsubscribe_rate)],
              ].map(([label, fn]) => (
                <tr key={label} className="border-t border-[#F5F5F5]">
                  <td className="px-5 py-2.5 font-semibold text-[#525252]">{label}</td>
                  {reports.map(r => <td key={r.campaign.id} className="px-4 py-2.5 text-right tabular-nums">{fn(r)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </MarketingShell>
  );
}
